<template>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="row">
                <div class="col-sm-12">
                    <h1>Campaign Name: {{ campaignDetails.name }}</h1>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="alert alert-info" v-if="alert_message">
                        {{ alert_message }}
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="box">
                        <div class="box-header">
                            <h3 class="box-title">
                                Discounted Price List For Coupon Code =
                                <span style="color: #f5cd00">{{ campaignDetails.coupon_code }}</span>
                            </h3>
                        </div>
                        <div class="box-body">
                            <div class="table-responsive">
                                <table class="table table-0024 table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th class="tdCenter tdSN">SN</th>
                                            <th class="">Package Name</th>
                                            <th class="tdCenter">Days</th>
                                            <th class="tdCenter">Extra Days</th>
                                            <th class="tdCenter">Price</th>
                                            <th class="tdCenter">Discount</th>
                                            <th class="tdCenter">Offer Price</th>
                                            <th class="tdCenter">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data, index) in discountList" :key="data.id">
                                            <td class="tdCenter tdSN">{{ index + 1 }}</td>
                                            <td class="">
                                                <span>
                                                    <i
                                                        :class="data.discount_amount > 0 ? 'fa fa-dot-circle-o text-green' : 'fa fa-dot-circle-o text-orange'"></i>
                                                </span>
                                                &nbsp;&nbsp;
                                                {{ data.rate_plan_detail ? data.rate_plan_detail.plan_name : 'N/A' }}
                                            </td>
                                            <td class="tdCenter">
                                                {{ data.rate_plan_detail ? data.rate_plan_detail.no_of_days : 'N/A' }}
                                            </td>
                                            <td class="tdCenter">
                                                {{ data.extra_bonus_validity_in_days || 0 }}
                                            </td>
                                            <td class="tdCenter">
                                                ${{ data.rate_plan_detail ? data.rate_plan_detail.price : '0.00' }}
                                            </td>
                                            <td class="tdCenter">
                                                {{ getDiscountLabel(data) }}
                                            </td>
                                            <td class="tdCenter">
                                                {{ getOfferPrice(data) }}
                                            </td>
                                            <td class="tdCenter">
                                                <router-link
                                                    :to="{ name: 'EditCampaignCouponDiscount', params: { id: data.id } }"
                                                    title="Edit Discount">
                                                    <i class="ion ion-ios-compose table-edit"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                        <tr v-if="discountList.length === 0">
                                            <td colspan="8" class="tdCenter" style="padding: 30px 0">
                                                <b>No Records Found</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="box-footer">
                            <router-link :to="{ name: 'CampaignCouponList' }" class="btn btn-sm btn-cancel">
                                Back to Campaign List
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "CampaignCouponDiscountList",
    data() {
        return {
            campaignId: null,
            campaignDetails: {},
            discountList: [],
            alert_message: "",
        };
    },
    created() {
        this.com_user_type_access([0, 5, 6, 7], true);
        this.campaignId = this.$route.params.id;
        if (this.campaignId) {
            this.loadCampaignWithDiscounts();
        }
    },
    methods: {
        loadCampaignWithDiscounts() {
            loader.show();
            axios
                .get("/campaigns/" + this.campaignId)
                .then((response) => {
                    this.campaignDetails = response.data.result;
                    this.discountList = response.data.result.discounts || [];
                    loader.hide();
                })
                .catch((error) => {
                    loader.hide();
                    this.com_errorHandel(error);
                });
        },
        getDiscountLabel(data) {
            if (!data.discount_amount || data.discount_amount == 0) {
                return "";
            }
            if (data.discount_type == 1) {
                return "$" + parseFloat(data.discount_amount).toFixed(2);
            } else {
                return parseFloat(data.discount_amount).toFixed(2) + "%";
            }
        },
        getOfferPrice(data) {
            if (!data.rate_plan_detail || !data.discount_amount || data.discount_amount == 0) {
                return "";
            }
            let price = parseFloat(data.rate_plan_detail.price);
            let discountAmount = parseFloat(data.discount_amount);
            let offerPrice = 0;

            if (data.discount_type == 1) {
                offerPrice = price - discountAmount;
            } else {
                offerPrice = price - (price * discountAmount) / 100;
            }

            return "$" + offerPrice.toFixed(2);
        },
    },
};
</script>

<style scoped>
.text-green {
    color: green;
}

.text-orange {
    color: orange;
}
</style>